import {
    CHANNELS,
    TARIFF_MODEL,
    CHANNELS_LIST,
    INCLUDED_PACKAGES,
    ADDITIONAL_PACKAGES,
    CHOSEN_TARIFF_MODEL,
    CHOSEN_ADDITIONAL_PACKAGES,
    TOTAL_SUBSCRIPTION,
    ORDER,
    CHOOSE_TARIFF_MODEL,
    CHOOSE_FREE_PACKAGE_1,
    CHOOSE_FREE_PACKAGE_2,
    CHOOSE_FREE_PACKAGE_3,
    MKD_MONTHLY,
    MKD,
    CHOOSE,
    CHOSEN,
    TARIFF_TYPE,
    CHANGE_TARIFF,
    CHANGE_TARIFF_WARNING,
    CHANGE,
    BACK,
    INCLUDED_CHANNELS_IN_PACKAGE_1,
    INCLUDED_CHANNELS_IN_PACKAGE_2,
    CHOOSE_CITY,
    CHOOSE_MUNICIPALITY,
    CHOSEN_FREE_PACKAGES,
    INCLUDED_REGIONAL_CHANNELS,
    INCLUDED_CHANNELS_IN_TARIFF,
    CHOOSE_CITY_MUNICIPALITY_TARIFF,
    CHOOSE_TARIFF,
    CHOOSE_FREE_PACKAGE_1_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW_FREE,
    CHOOSE_FREE_PACKAGE_3_NEW,
    CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
    PRICE_INCLUDE_VAT,
    DVBT_OFFER_CHANNELS, TV_CHANNELS, AVAILABLE
} from "./keys";

export const alContent = [
    {
        key: CHOOSE_TARIFF_MODEL,
        value: 'Zgjidhni një nga modelet tarifore të ofruara'
    },
    {
        key: TARIFF_MODEL,
        value: 'Modelin tarifor'
    },
    {
        key: TARIFF_TYPE,
        value: 'Lloji i tarifës'
    },
    {
        key: CHANNELS,
        value: 'Kanale'
    },
    {
        key: CHANNELS_LIST,
        value: 'Lista e kanaleve televizive'
    },
    {
        key: INCLUDED_PACKAGES,
        value: 'TV kanale të përfshira'
    },
    {
        key: CHOOSE_FREE_PACKAGE_1,
        value: 'ZGJIDHNI'
    },
    {
        key: CHOOSE_FREE_PACKAGE_2,
        value: ' NGA PAKOT VIJUESE'
    },
    {
        key: CHOOSE_FREE_PACKAGE_3,
        value: 'të cilat mund t’i përfshini falas në tarifën e zgjedhur'
    },
    {
        key: ADDITIONAL_PACKAGES,
        value: 'Pako shtesë'
    },
    {
        key: CHOSEN_TARIFF_MODEL,
        value: 'Modeli tarifor i zgjedhur'
    },
    {
        key: CHOSEN_FREE_PACKAGES,
        value: 'Pakot e zgjedhura falas'
    },
    {
        key: CHOSEN_ADDITIONAL_PACKAGES,
        value: 'Pakot e zgjedhura shtesë '
    },
    {
        key: TOTAL_SUBSCRIPTION,
        value: 'Parapagimi total'
    },
    {
        key: ORDER,
        value: 'Porosit'
    },
    {
        key: MKD_MONTHLY,
        value: 'den. pagesa mujore'
    },
    {
        key: MKD,
        value: 'den.'
    },
    {
        key: CHOOSE,
        value: 'Zgjidh'
    },
    {
        key: CHOSEN,
        value: 'I zgjedhur'
    },
    {
        key: INCLUDED_CHANNELS_IN_PACKAGE_1,
        value: 'Kanale të përfshira në '
    },
    {
        key: INCLUDED_CHANNELS_IN_PACKAGE_2,
        value: ' pako'
    },
    {
        key: CHANGE_TARIFF,
        value: 'Ndryshimi i tarifës'
    },
    {
        key: CHANGE_TARIFF_WARNING,
        value: 'Ndryshimi i tarifës do të fshijë pakot që keni zgjedhur tashmë. A jeni të sigurtë që dëshironi të ndërroni tarifën?'
    },
    {
        key: CHANGE,
        value: 'Ndrysho'
    },
    {
        key: BACK,
        value: 'Prapa'
    },
    {
        key: CHOOSE_CITY,
        value: 'Zgjidhni qytetin'
    },
    {
        key: CHOOSE_MUNICIPALITY,
        value: 'Zgjidhni komunën'
    },
    {
        key: INCLUDED_REGIONAL_CHANNELS,
        value: 'TV kanalet regjionale janë përfshirë falas në tarifën e zgjedhur dhe numri varet nga regjioni ku përdoret TV shërbimi.'
    },
    {
        key:INCLUDED_CHANNELS_IN_TARIFF,
        value: 'TV kanale të përfshira në tarifën e zgjedhur'
    },
    {
        key: CHOOSE_CITY_MUNICIPALITY_TARIFF,
        value: 'Për të parë TV-kanalet e përfshira, zgjedhni qytetin, komunën dhe tarifën'
    },
    {
        key: CHOOSE_TARIFF,
        value: 'Zgjidhni një tarifë'
    },
    {
        key:CHOOSE_FREE_PACKAGE_1_NEW,
        value: 'Me tarifën e përzgjedhur, '
    },
    {
        key:CHOOSE_FREE_PACKAGE_2_NEW,
        value: 'nga TV pakot e mëposhtme i fitoni '
    },
    {
        key:CHOOSE_FREE_PACKAGE_2_NEW_FREE,
        value:'falas.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW,
        value: 'TV-pakot tjera mund t’i aktivizoni me parapagimet mujore të dhëna.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
        value: 'Pakoja HBO Premium Lite është në dispozicion vetëm me parapagim mujor.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
        value: 'Pakoja HBO Premium është në dispozicion vetëm me parapagim mujor.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
        value: 'TV pako që mund t\'i aktivizoni me parapagimet mujore të dhëna.'
    },
    {
        key:PRICE_INCLUDE_VAT,
        value: 'Të gjitha çmimet përmbajnë TVSh.'
    },
    {
        key:DVBT_OFFER_CHANNELS,
        value: 'Oferta me numrin e dhënë të TV- kanaleve është në dispozicion me teknologji optike ose kabllovike. Nëse në vendndodhjen Tuaj nuk ka mundësi teknike për këto teknologji, atëherë do t\'Ju ofrohet teknologjia DVBT për të cilën janë në dispozicion'
    },
    {
        key: TV_CHANNELS,
        value: 'TV-kanalet'
    },
    {
        key: AVAILABLE,
        value: 'e mëposhtme televizive.'
    }
];
